<template>
  <div class="calcu-body buyness-calcu">
    <van-form class="form-bg">
      <!-- 计算方式 -->
      <van-field name="radio" label="计算方式" class="cal-method">
        <template #input>
          <van-radio-group
            v-model="formData.methodType"
            direction="horizontal"
            @change="calcuMethodChange"
          >
            <div class="radioDiv">
              <van-radio
                name="2"
                :class="
                  Number(formData.methodType) === 2 ? 'active' : 'inactive'
                "
              >
                <div class="radio-text">按贷款总额</div></van-radio
              ><van-radio
                name="1"
                :class="
                  Number(formData.methodType) === 1 ? 'active' : 'inactive'
                "
              >
                <div class="radio-text">按房屋总价</div>
              </van-radio>
            </div>
          </van-radio-group>
        </template>
      </van-field>

      <!-- 房屋总价 -->
      <van-field
        v-model="formData.houseTotal"
        type="number"
        name="房屋总价"
        label="房屋总价"
        autocomplete="off"
        placeholder="请输入房屋总价"
        v-if="formData.calcuMethod === '按房屋总价'"
        @focus="houseTotalFocus"
        @click="houseKeyboardShow = true"
      >
        <template #input>
          <div @click="houseTotalFocus" class="input-container">
            <span>{{ formData.houseTotal }}</span>
            <div
              :style="houseKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">万</span>
        </template>
      </van-field>

      <!-- 房屋总价的数字键盘 -->
      <van-number-keyboard
        :show="houseKeyboardShow"
        v-model="formData.houseTotal"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="houseKeyboardClose"
        @blur="houseKeyboardClose"
        style="z-index: 3000"
      />

      <!-- 首付比例 -->
      <van-field
        v-model="formData.downPayment"
        name="radio"
        label="首付比例"
        v-if="formData.calcuMethod === '按房屋总价'"
        @click-input="shoufuKeyboardShow = true"
        @click-left-icon="handleownPayment"
        readonly
      >
        <template #input>
          <div @click="shoufuKeyboardShow = true" class="input-container">
            <span>{{ formData.downPayment }}</span>
            <div
              :style="shoufuKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix"> %</span>
        </template>
      </van-field>
      <van-number-keyboard
        :show="shoufuKeyboardShow"
        v-model="formData.downPayment"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="shoufuKeyboardClose"
        @blur="shoufuKeyboardClose"
        style="z-index: 3000"
      />
      <!-- 贷款总额 -->
      <van-field
        v-model="formData.total"
        type="number"
        name="商贷金额"
        label="商贷金额"
        placeholder="请输入商贷金额"
        autocomplete="off"
        @focus="totalFocus"
        @click="totalkeyboardShow = true"
        readonly
      >
        <template #input>
          <div @click="totalFocus" class="input-container">
            <span>{{ formData.total }}</span>
            <div
              :style="totalkeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">万</span>
        </template>
      </van-field>
      <!-- 商贷金额-数字键盘 -->
      <van-number-keyboard
        :show="totalkeyboardShow"
        v-model="formData.total"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="totalKeyboardClose(true)"
        @blur="totalKeyboardClose(false)"
        style="z-index: 3000"
      />

      <!-- 商贷年限 -->
      <van-field
        readonly
        clickable
        v-model="formData.loanTerm"
        label="商贷年限"
        placeholder="点击选择商贷年限"
        @focus="showLoanTermPicker = true"
        @click-right-icon="showLoanTermPicker = true"
      >
        <template #right-icon>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>
      <keep-alive>
        <van-popup v-model="showLoanTermPicker" round position="bottom">
          <van-picker
            title="商贷年限"
            show-toolbar
            :default-index="
              loanTermList.findIndex((item) => formData.loanTerm === item) || 0
            "
            :columns="loanTermList"
            @confirm="onLoanTermComplete"
            @cancel="showLoanTermPicker = false"
        /></van-popup>
      </keep-alive>
      <!-- 利率方式 -->
      <van-field
        readonly
        clickable
        v-model="formData.interestRateMethod"
        label="利率方式"
        placeholder="点击选择利率方式"
        @focus="showInterestRatePicker = true"
        @click-right-icon="showInterestRatePicker = true"
      >
        <template #right-icon>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>
      <div class="LprDiv" v-if="formData.interestRateMethod == '按LPR'">
        <span class="LprText">
          {{
            `LPR: 一年期${this.com_rate["1"][0].value}%，五年期${this.com_rate_1["1"][0].value}%`
          }}</span
        >
      </div>
      <keep-alive>
        <van-popup v-model="showInterestRatePicker" round position="bottom">
          <van-picker
            title="利率方式"
            show-toolbar
            :columns="interestRateMethodList"
            @confirm="onInterestRateComplete"
            @cancel="showInterestRatePicker = false"
        /></van-popup>
        <!-- <NewPicker
          title="利率2方式"
          :pickList="interestRateMethodList"
          typeKey="interestRate"
          v-if="showInterestRatePicker"
          @pickerHandle="pickerHandle"
          @pickerClose="pickerClose"
        ></NewPicker> -->
      </keep-alive>
      <!-- 商贷利率  -->
      <van-field
        v-if="formData.interestRateMethod != '按LPR'"
        readonly
        clickable
        v-model="formData.rate"
        label="商贷利率"
        placeholder="点击选择利率方式"
        @focus="showRatePicker = true"
        @click-left-icon="handleRateHelp"
        @click-right-icon="showRatePicker = true"
      >
        <template #left-icon>
          <img
            src="../../assets/image/help.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
        <template #right-icon>
          <span v-if="spanShow" class="suffix"> % </span>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>

      <van-field
        class="rateInput"
        v-if="formData.interestRateMethod === '按LPR'"
        v-model="formData.customRate"
        type="number"
        name="商贷利率"
        label="商贷利率"
        autocomplete="off"
        placeholder="请输入贷款利率"
        @click-left-icon="handleRateHelp"
        @focus="rateFocus"
        @click-right-icon="rateFocus"
      >
        <template #left-icon>
          <img
            src="../../assets/image/help.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
        <template #input>
          <div @click="rateFocus" class="input-container">
            <span>{{ formData.customRate }}</span>
            <div
              :style="rateKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">%</span>
        </template>
      </van-field>

      <!-- 商贷利率-数字键盘 -->
      <van-number-keyboard
        :show="rateKeyboardShow"
        v-model="formData.customRate"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="rateKeyboardClose(true)"
        @blur="rateKeyboardClose(false)"
        style="z-index: 3000"
      />

      <keep-alive>
        <NewPicker
          :title="
            formData.interestRateMethod === '按LPR' ? '本月LPR' : '旧版基准利率'
          "
          :pickList="
            formData.interestRateMethod === '按LPR' ? rateList : rateBaseList
          "
          typeKey="rate"
          v-if="showRatePicker"
          @pickerHandle="pickerHandle"
          @pickerClose="pickerClose"
          @clickPicker="handleCustomRate(true)"
        >
          <template #footer>
            <div class="picker-footer">
              <span>自定义输入</span>
              <input
                type="text"
                placeholder="请输入贷款利率"
                v-model="formData.customRate"
              />%
              <!-- <button class="customer-btn" @click="handleCustomRate">
                确定
              </button> -->
            </div>
          </template>
        </NewPicker>
      </keep-alive>

      <!-- 自定义贷款利率的数字键盘 -->
      <van-number-keyboard
        :show="customRatekeyboardShow"
        v-model="formData.customRate"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="customRateKeyboardClose"
        @blur="customRateKeyboardClose"
        style="z-index: 3000"
      />

      <div style="margin-top: 14px; margin-left: 22px">
        <van-button class="submit-btn" @click="handleSubmit"
          >开始计算</van-button
        >
      </div>

      <div
        v-if="placeDiv || rateKeyboardShow || customRatekeyboardShow"
        class="placeDiv"
      ></div>
    </van-form>

    <!-- 模态框 -->
    <van-dialog
      v-model="customModalShow"
      show-cancel-button
      confirm-button-color="#FFCC33"
      @confirm="modalConfirm"
      @cancel="modalCancel"
    >
      <template #default>
        <div class="custom-dialog-content">
          目前商贷年限最大{{
            this.$store.state.location.cityId == 1 ? 25 : 30
          }}年，您确定查看吗？
        </div>
      </template>
    </van-dialog>
    <!-- 提交提示loading-->
    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import $http from "../../utils/request";
import { totalNumValidate, CustomDownPaymentNum } from "../../validate/index";
import { mapState } from "vuex";
import Picker from "../../components/Picker";
import NewPicker from "../../components/NewPicker";
import Loading from "../../components/loading";
import { getWebViewEnv } from "../../utils/app-bridge";

export default {
  components: {
    Picker,
    NewPicker,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      showMehodsPicker: false,
      methodsList: ["按房屋总价", "按贷款总额"],
      showLoanTermPicker: false,
      showInterestRatePicker: false,
      interestRateMethodList: ["按LPR", "旧版基准利率"],
      showRatePicker: false,
      spanShow: false,
      showDownPaymentPicker: false,
      placeDiv: false,
      formData: {
        total: "0",
        calcuMethod: this.$route.query.cal || "按贷款总额",
        loanTerm: "",
        customTerm: "",
        interestRateMethod: "按LPR",
        rate: "",
        customRate: "",
        houseTotal: "0",
        isFirst: "1",
        methodType: "2",
        downPayment: this.$store.state.first_downpayment_percent,
        customDownPayment: "",
      },
      customModalShow: false,
      selectedPayment: false,
      totalkeyboardShow: false,
      houseKeyboardShow: false,
      shoufuKeyboardShow: false,
      rateKeyboardShow: false,
      customDownPaymentKeyboardShow: false,
      customTermkeyboardShow: false,
      customRatekeyboardShow: false,
      blurBool: false,
    };
  },
  created() {
    if (this.$route.query.broker_id) {
      const { broker_id, user_id } = this.$route.query;
      this.$store.commit("setPeople", {
        broker_id,
        user_id,
      });
    }
  },
  watch: {
    loanTermList: {
      handler(newVal) {
        if (newVal) {
          this.formData.loanTerm = newVal[newVal.length - 1];
        }
      },
      immediate: true,
    },

    // 监听后端给出的贷款利率，设置默认值
    rateList: {
      handler(newVal) {
        if (newVal && this.formData.interestRateMethod === "按LPR") {
          this.formData.rate = newVal[0].value;
          this.formData.customRate = newVal[0].value;
        }
      },
      immediate: true,
    },
    rateBaseList: {
      handler(newVal) {
        if (newVal && this.formData.interestRateMethod === "旧版基准利率") {
          this.formData.rate = newVal[0].text;
        }
      },
    },
    downPayment: {
      handler(newVal) {
        this.formData.downPayment = newVal;
      },
    },
  },
  methods: {
    inputReg(e) {
      if (this.formData.customTerm.length == 1 && e.data == 0) {
        this.formData.customTerm = "";
      } else {
        let inputReg = this.formData.customTerm.replace(/[^0-9]/g, "");
        this.formData.customTerm = inputReg;
      }
    },
    pickerClose(typeKey) {
      console.log("close typeKey---->", typeKey);
      switch (typeKey) {
        case "loanTerm":
          this.showLoanTermPicker = false;
          break;
        case "interestRate":
          this.showInterestRatePicker = false;
          break;
        case "rate":
          this.showRatePicker = false;
          break;
      }
    },
    pickerHandle(isShow, selected, typeKey) {
      switch (typeKey) {
        case "interestRate":
          this.onInterestRateComplete(selected);
          if (this.formData.interestRateMethod === "旧版基准利率") {
            this.formData.customRate = "";
          }
          if (this.formData.interestRateMethod === "按LPR") {
            this.formData.customRate = this.rateList[0].value;
          }
          break;
        case "rate":
          this.onRateComplete(selected);
          break;
      }
      // this.pickerShow = isShow;
    },
    // 自定义贷款利率的数字键盘关闭
    customRateKeyboardClose() {
      this.customRatekeyboardShow = false;
    },
    loanTermChange(value) {
      console.log(loanTermList, "this.$store.state.first_downpayment_percent");
      console.log(value, "-=-=");
    },
    // 自定义首付比例的数字键盘关闭
    // customDownPaymentKeyboardClose() {
    //   this.customDownPaymentKeyboardShow = false;
    // },
    // 贷款总额的数字键盘关闭
    totalKeyboardClose(bool) {
      this.formData.total = totalNumValidate(this.formData.total, this, bool);
      this.totalkeyboardShow = false;
    },

    //输入=====商贷利率
    rateFocus() {
      this.rateKeyboardShow = true;
      this.placeDiv = true;
      if (this.formData.rate == 0) {
        this.formData.rate = "";
      }
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 50);
      document.activeElement.blur();
    },
    rateKeyboardClose(bool) {
      this.placeDiv = false;
      this.handleCustomRate(bool);
      this.rateKeyboardShow = false;
    },
    // 房屋总价的数字键盘关闭
    houseKeyboardClose() {
      if (this.formData.houseTotal) {
        this.onHouseTotal(this.formData.houseTotal);
      }
      this.houseKeyboardShow = false;
    },
    // 首付比例的数字键盘关闭
    shoufuKeyboardClose() {
      if (this.formData.downPayment) {
        this.onDownPayment(this.formData.downPayment);
      }
      this.shoufuKeyboardShow = false;
    },
    totalFocus() {
      if (this.formData.total == 0) {
        this.formData.total = "";
      }
      document.activeElement.blur();
    },
    houseTotalFocus() {
      if (this.formData.houseTotal == 0) {
        this.formData.houseTotal = "";
      }
      document.activeElement.blur();
    },
    linkLocation() {
      // 点击选择城市
      this.$router.push("/location");
    },
    handleLocation() {
      // 点击选择城市前的问号
      this.$store.commit("showLocationModal", true);
    },
    handleSubmit() {
      if (this.formData.calcuMethod === "按贷款总额") {
        if (!Number(this.formData.total)) {
          this.$toast("请输入大于0金额");
          this.formData.total = "0";
          return;
        }
      } else if (this.formData.calcuMethod === "按房屋总价") {
        if (!Number(this.formData.houseTotal)) {
          this.$toast("请输入大于0的金额");
          this.formData.houseTotal = "0";
          return;
        } else if (!Number(this.formData.total)) {
          this.$toast("请输入大于0金额");
          this.formData.total = "0";
          return;
        }
      }
      const data = {};

      data.com_loan_time = parseInt(this.formData.loanTerm); // 商贷年限
      data.com_loan_value = Number(this.formData.total); // 贷款总额
      if (this.formData.calcuMethod === "按房屋总价") {
        data.house_price = Number(this.formData.houseTotal);
        // data.payment_percent =
        //   parseFloat(
        //     document.getElementsByClassName("down-payment-per")[0].innerText
        //   ) / 100;
      } else {
        // 为保证参数的完整性，页面上不存在的参数传空字符串（后端要求）
        data.is_first = "";
        data.house_price = "";
        data.payment_percent = "";
      }
      // 需要判断当前是否为自定义贷款利率，当前若为自定义贷款利率则直接取自定义贷款利率，否则按利率方式判断！
      if (this.formData.customRate) {
        if (this.formData.interestRateMethod === "按LPR") {
          if (this.isLprCustom()) {
            // console.log('if===',this.formData.rate)
            data.com_loan_rate = Number(this.formData.customRate) / 100;
          } else {
            return;
          }
        } else {
          data.com_loan_rate =
            Number(
              this.rateBaseList.find((item) => item.text === this.formData.rate)
                ?.value,
            ) / 100 || Number(this.formData.rate) / 100; // 商贷利率
        }
      } else {
        if (this.formData.interestRateMethod === "按LPR") {
          if (this.isLprCustom()) {
            data.com_loan_rate = Number(this.formData.rate) / 100;
          } else {
            return;
          }
        } else {
          data.com_loan_rate =
            Number(
              this.rateBaseList.find((item) => item.text === this.formData.rate)
                ?.value,
            ) / 100; // 商贷利率
        }
      }

      // 为保证参数的完整性，页面上不存在的参数传空字符串（后端要求）
      data.fund_loan_time = "";
      data.fund_loan_value = "";
      data.fund_loan_rate = "";

      // 如果有经纪人信息给经纪人推送
      if (this.peopleInfo.broker_id) {
        const { broker_id, user_id } = this.peopleInfo;
        data.user_id = user_id;
        data.broker_id = broker_id;
        data.result_url = `${
          window.location.origin
        }/calculator/#/CommercialIoanDetailed?type=busness&cal=${
          this.formData.calcuMethod
        }&form=${encodeURIComponent(JSON.stringify(data))}&cityid=${
          this.$store.state.location.cityId
        }&cityname=${this.$store.state.location.cityName}&hideBroker=${
          this.$route.query?.hideBroker
        }`;
        console.log(data.result_url, "(data.result_url)");
      }

      this.isLoading = true;
      data.platform = getWebViewEnv();

      // TODO 表单提交
      $http({
        url: `/appapi/normals/${this.$store.state.location.cityId}/v1/loandetails`,
        method: "post",
        data,
      })
        .then((res) => {
          if (res.msg == "OK") {
            // 存入store中
            this.$store.dispatch("setCalcuRes", res.data);
            // 在localStorage中做本地持久化
            localStorage.setItem("calcuRes", JSON.stringify(res.data));
            this.isLoading = false;
            this.$router.push(
              `/CommercialIoanDetailed?type=busness&cal=${this.formData.calcuMethod}&cityid=${this.$store.state.location.cityId}&cityname=${this.$store.state.location.cityName}&hideBroker=${this.$route.query?.hideBroker}`,
            );
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("err--->", err);
        });
    },
    // 商贷年限弹出框的完成
    onLoanTermComplete(value) {
      this.formData.loanTerm = value;
      if (this.formData.interestRateMethod === "按LPR") {
        if (parseInt(this.formData.loanTerm) > 1) {
          this.formData.rate = this.com_rate_1["1"][0].text;
        } else {
          this.formData.rate = this.com_rate["1"][0].text;
        }
      }
      // 清空自定义填写项
      this.formData.customTerm = "";
      this.showLoanTermPicker = false;
    },
    onInterestRateComplete(value) {
      this.formData.interestRateMethod = value;

      if (this.formData.interestRateMethod === "按LPR") {
        this.formData.rate = this.rateList[0].text;
        this.formData.customRate = this.rateList[0].value;
      } else {
        this.formData.rate = this.rateBaseList[0].text;
        this.formData.customRate = "";
      }
      this.showInterestRatePicker = false;
    },
    modalConfirm() {
      if (this.formData.interestRateMethod === "按LPR") {
        if (parseInt(this.formData.loanTerm) > 1) {
          this.formData.rate = this.com_rate_1["1"][0].text;
        } else {
          this.formData.rate = this.com_rate["1"][0].text;
        }
      }
      // TODO 模态框确定
      this.customModalShow = false;
      this.showLoanTermPicker = false;
      this.formData.loanTerm = `${this.formData.customTerm}年`;
    },
    modalCancel() {
      // TODO 模态框取消
      this.formData.customTerm = "";
    },
    onRateComplete(item) {
      this.formData.rate = item.text;
      this.showRatePicker = false;
    },
    handleRateHelp() {
      this.$store.commit("showRateModal", true);
    },
    handleownPayment() {
      this.$store.commit("showHouseModal", true);
    },
    handleCustomRate(bool) {
      console.log("自定义利率", Number(this.formData.customRate));
      const valueStr = String(parseInt(this.formData.customRate));
      const dicStr = String(this.formData.customRate).split(".")[1];
      if (Number(this.formData.customRate) > 0) {
        if (dicStr?.length > 4) {
          this.$toast("最多输入4位小数");
          this.formData.customRate =
            String(this.formData.customRate).split(".")[0] +
            "." +
            dicStr.substring(0, 4);

          this.formData.rate = this.formData.customRate;
        } else if (
          valueStr.length > 3 ||
          Number(this.formData.customRate) > 100
        ) {
          this.$toast("输入数值过大，请重新输入");
          this.formData.customRate = "";
        } else {
          this.formData.rate = this.formData.customRate;
          this.showRatePicker = false;
          this.customRatekeyboardShow = false;
          this.spanShow = true;
        }
      } else {
        this.formData.customRate = "";
        if (bool) {
          this.$toast("请输入大于0的数值");
        }
      }
    },
    isLprCustom() {
      // this.formData.rate
      const LPRreg = /(^[0-9]{1,2}$)|(^[0-9]{1,2}[\.]{1}[0-9]{1,5}$)/;
      const isLPRExit =
        LPRreg.test(this.formData.customRate) &&
        Number(this.formData.customRate) > 0;

      if (this.formData.customRate == 0 || this.formData.customRate == "") {
        // this.$toast("请输入大于0的数字");
        this.$toast("请将商贷利率修改为大于0，小于100的数字，支持小数点后五位");
        return false;
      }
      if (!/^\d+(\.\d{1,5})?$/.test(this.formData.customRate)) {
        // this.$toast("最多支持小数点后5位");
        this.$toast("请将商贷利率修改为大于0，小于100的数字，支持小数点后五位");
        return false;
      }
      if (!isLPRExit) {
        // this.$toast("请输入小于100的数字");
        this.$toast("请将商贷利率修改为大于0，小于100的数字，支持小数点后五位");
        return false;
      }
      return true;
    },
    onHouseTotal(value) {
      let defaultPercent = "";
      // 房屋总价的输入监听
      if (Number(value)) {
        const valueStr = String(parseInt(value));
        const dicStr = String(value).split(".")[1]
          ? String(value).split(".")[1]
          : "00";
        if (valueStr.length > 5 || Number(value) > 99999) {
          this.$toast("输入数值过大，请重新输入");
          this.formData.houseTotal = 0;
        } else {
          if (dicStr.length > 2) {
            this.$toast("最多输入2位小数");
            this.formData.houseTotal =
              String(value).split(".")[0] + "." + dicStr.substr(0, 2);
          }
        }

        defaultPercent = this.formData.downPayment;
        this.formData.total =
          (Number(this.formData.houseTotal) *
            (100 - parseInt(defaultPercent))) /
          100;
        this.formData.total = Number(this.formData.total).toFixed(2);
      } else {
        this.$toast("请输入大于0的数值");
        this.formData.total = 0;
      }
    },
    onDownPayment(value) {
      // 首付比例输入监听

      if (Number(value)) {
        const valueStr = String(parseInt(value));
        const dicStr = String(value).split(".")[1];

        if (dicStr) {
          this.$toast("请输入整数");
          this.formData.downPayment = valueStr;
        } else if (Number(valueStr) > 100) {
          this.$toast("输入值过大,请重新输入");
          this.formData.downPayment =
            this.$store.state.first_downpayment_percent;
        } else {
          this.formData.downPayment = value;
        }
        this.formData.total =
          (Number(this.formData.houseTotal) *
            (100 - parseInt(this.formData.downPayment))) /
          (100).toFixed(2);
      }
    },
    calcuMethodChange(name) {
      if (name === "1") {
        this.formData.calcuMethod = "按房屋总价";
      } else if (name === "2") {
        this.formData.calcuMethod = "按贷款总额";
      }
    },
    isFirstChange(name) {
      this.selectedPayment = false;
      if (name === "1") {
        this.formData.total = (
          (Number(this.formData.houseTotal) *
            (100 - parseInt(this.firstDefault))) /
          100
        ).toFixed(2);
      } else if (name === "2") {
        this.formData.total = (
          (Number(this.formData.houseTotal) *
            (100 - parseInt(this.secondDefault))) /
          100
        ).toFixed(2);
      }
    },
  },
  computed: {
    defaultCal() {
      if (this.$route.query.cal) {
        if (this.$route.query.cal === "按贷款总额") {
          return 1;
        } else if (this.$route.query.cal === "按房屋总价") {
          return 0;
        }
      } else {
        return 1;
      }
    },
    peopleInfo() {
      return this.$store.state.people;
    },
    locationCity() {
      return this.$store.state.location.cityName;
    },
    ...mapState({
      com_rate: (state) => {
        return state.com_rate;
      },
      com_rate_1: (state) => state.com_rate_1,
    }),
    rateList() {
      return parseInt(this.formData.loanTerm) > 1
        ? this.com_rate_1["1"]
        : this.com_rate["1"];
    },
    rateBaseList() {
      return parseInt(this.formData.loanTerm) > 1
        ? this.com_rate_1["2"]
        : this.com_rate["2"];
    },
    loanTermList() {
      return this.$store.state.loanTime;
    },
    downPayment() {
      return this.$store.state.first_downpayment_percent;
    },
  },
};
</script>

<style scoped>
.calcu-body {
  width: 714px;
  margin: 24px auto;
  border-radius: 16px;
  overflow: hidden;
}
.form-bg {
  background-color: #ffffff;
  padding-bottom: 25px;
}
.submit-btn {
  width: 638px;
  height: 96px;
  border-radius: 16px;
  line-height: 96px;
  background-color: #ffcc33;
  border: none;
  font-size: 28px;
  color: #333333;
  font-weight: 600;
}
.placeDiv {
  height: 300px;
  width: 100%;
}
.LprDiv {
  width: 666px;
  height: 72px;
  background: #fff9e5;
  border-radius: 12px;
  margin-top: 24px;
  margin-left: 24px;
  display: flex;
  align-items: center;
}
.LprText {
  display: block;
  margin-left: 32px;
  font-weight: 400;
  font-size: 28px;
  color: #222222;
  line-height: 40px;
}
.calcu-body /deep/ .van-cell {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 48px;
  height: 129px;
  box-sizing: border-box;
}

.calcu-body /deep/ .van-field__left-icon {
  position: absolute;
  top: 64px;
  left: 145px;
}
.calcu-body /deep/ .van-cell__title {
  color: #292b33;
  font-weight: bold;
  font-size: 32px;
}
.calcu-body /deep/ .van-field__body input,
.suffix {
  font-size: 28px;
  color: #333;
}
.input-container {
  width: 100%;
  display: flex;
  align-items: center;
}
.calcu-body .cursor {
  margin-left: 2px;
  height: 30px;
  width: 1px;
  opacity: 0;
  background: url("https://static-official.5i5j.com/offical/cdn/5e00398904093f6aca4be6a71ba652e1_1720433382281.gif")
    no-repeat center center;
}
.radioDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.calcu-body /deep/ .van-radio--horizontal {
  margin-right: 12px;
}
.radioDiv .active {
  width: 234px;
  height: 76px;
  background: url("https://static-official.5i5j.com/offical/cdn/8d4520f04014bfa00ce00e775c946ad8_1731550918382.png")
    no-repeat;
  background-size: 234px 76px;
  font-weight: 600;
  color: #222222;
}
.radioDiv .inactive {
  background: url("https://static-official.5i5j.com/offical/cdn/1180cf092a9e7e1b81b02ffdffefa6ff_1731563918501.png")
    no-repeat;
  background-size: 234px 76px;
  font-weight: 400;
  color: #666666;
}
.radio-text {
  width: 234px;
  height: 76px;
  font-size: 28px;
  text-align: center;
  line-height: 76px;
  font-style: normal;
}
.rateInput {
  position: relative;
}
.cal-method /deep/ .van-radio__label {
  margin-left: 0;
}
.van-cell:after {
  border-bottom: 0px !important;
}
.calcu-body /deep/ .van-cell:not(:first-child) .van-field__value {
  background-color: #f9f9f9 !important;
  width: 482px;
  height: 76px;
  border: 2px solid #eeeeee;
  border-radius: 12px;
  font-weight: 600;
  font-size: 28px;
  color: #222222;
  line-height: 76px;
  padding-left: 32px;
  padding-right: 32px;
}

.calcu-body /deep/ .van-field__label {
  height: 76px;
  width: 120px;
  font-weight: 500;
  font-size: 28px;
  color: #222222;
  line-height: 76px;
  margin-right: 62px;
}
.calcu-body /deep/ .van-radio-group .van-radio:last-child {
  margin-right: 0;
}
.calcu-body /deep/ .van-radio__icon .van-icon {
  display: none;
}
.popup-title {
  width: 670px;
  height: 112px;
  border-bottom: 2px solid #eeeeee;
  line-height: 112px;
  font-size: 32px;
  color: #333;
  margin: 0 auto;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.popup-title .complete {
  color: #ffcc33;
}
.custom-term {
  height: 112px;
  width: 670px;
  margin: 0 auto;
  border-top: 2px solid #eeeeee;
}
.customer-btn {
  color: #333;
  border: none;
  outline: none;
}
.custom-dialog-content {
  text-align: center;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 25px 48px 25px;
  padding-top: 80px;
  width: 568px;
  height: 218px;
  font-size: 30px;
  font-weight: 500;
  color: #333333;
  line-height: 45px;
  letter-spacing: 1px;
}
.down-payment-per {
  display: inline-block;
}
.margin-b-244 {
  margin-bottom: 488px;
}
</style>
